/*
 * environment (utils)
 */
import { capitalizeFirstLetter } from "./format.utils"

export const AppBuilt = process.env["APP_BUILT"] || "unknown"
export const AppEnv = process.env["APP_ENV"] || "local"
export const AppPlatform = process.env["APP_PLATFORM"] || "unknown"
export const AppSHA = (process.env["APP_SHA"] || "-").slice(0, 7)
export const AppTitle = process.env["APP_TITLE"] || "Unknown"
export const AppVersion = process.env["APP_VERSION"] || "-"

export const Environment = capitalizeFirstLetter(
	AppEnv === "dev" ? "development" : AppEnv === "prod" ? "production" : AppEnv,
	true,
)

export const isLocal = AppEnv === "local"
export const isDev = AppEnv === "dev"
export const isProd = AppEnv === "prod"

export const isDebug =
	process.env["VITE_DEBUG_MODE"] || process.env["DEBUG_MODE"] === "true"
